import { render } from "./TermsOfService.vue?vue&type=template&id=26676336&scoped=true&ts=true"
import script from "./TermsOfService.vue?vue&type=script&lang=ts"
export * from "./TermsOfService.vue?vue&type=script&lang=ts"

import "./TermsOfService.vue?vue&type=style&index=0&id=26676336&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26676336"]])

export default __exports__